/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import theme from '@salesforce/retail-react-app/app/components/shared/theme';

/**
 * App theme styles
 *
 * Header chrome: sticky on desktop only. Mobile stays in document flow
 * so hide-on-scroll cannot overlap in-page sticky rows (account nav).
 */
export default {
  baseStyle: {
    container: {
      backgroundColor: 'brandColors.primaryBG',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      minWidth: '345px',
    },
    headerWrapper: {
      position: {base: 'static', lg: 'sticky'},
      top: 0,
      transform: 'translateY(0)',
      transition: 'transform 300ms cubic-bezier(0.16, 1, 0.3, 1)',
      zIndex: theme.zIndices.sticky,
      '&[data-header-hidden="true"]': {
        transform: 'translateY(-100%)',
        transition: 'transform 200ms cubic-bezier(0.4, 0, 1, 1)',
      },
      '@media (prefers-reduced-motion: reduce)': {
        transition: 'none',
        '&[data-header-hidden="true"]': {
          transition: 'none',
        },
      },
    },
  },
  parts: ['container', 'headerWrapper'],
};
